export enum BodyStyleClassesEnum {
  ORIENTATION_LANDSCAPE = 'orientation-landscape',
  ORIENTATION_PORTRAIT = 'orientation-portrait',
  SCREEN_LARGE = 'screen-large',
  SCREEN_SMALL = 'screen-small',
  SIDENAV_OPEN = 'sidenav-open',
}
